import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import './ConfiguracoesIA.css';

const DEFAULT_REGRAS = {
  max_chars: 150,
  allow_prices: false,
  ask_name_once: true,
  use_name_max_times: 1,
  handoff_on_price: true,
  handoff_on_image_request: true,
  handoff_on_wholesale: true,
  handoff_phrase: 'Vou direcionar você para uma atendente. Um momento por favor.',
  availability_mode: 'whitelist_only'
};

const API_BASE = 'https://welaunchyou.com.br/crm-wly/api/openai';

const cardStyle = {
  background: '#fff',
  border: '1px solid #e5e7eb',
  borderRadius: 16,
  padding: 20,
  boxShadow: '0 6px 24px rgba(15, 23, 42, 0.05)',
  marginBottom: 18
};

const sectionTitleStyle = {
  fontSize: 18,
  fontWeight: 700,
  color: '#111827',
  marginBottom: 6
};

const sectionDescStyle = {
  fontSize: 13,
  color: '#6b7280',
  marginBottom: 18,
  lineHeight: 1.5
};

const grid2 = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: 16
};

const inputStyle = {
  width: '100%',
  border: '1px solid #d1d5db',
  borderRadius: 10,
  padding: '11px 12px',
  fontSize: 14,
  backgroundColor: '#fff',
  boxSizing: 'border-box'
};

const helpStyle = {
  fontSize: 12,
  color: '#6b7280',
  marginTop: 6,
  lineHeight: 1.45
};

const labelRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  marginBottom: 10
};

const tagStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 12,
  fontWeight: 600,
  color: '#065f46',
  background: '#ecfdf5',
  border: '1px solid #a7f3d0',
  borderRadius: 999,
  padding: '6px 10px'
};

const dangerTagStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 12,
  fontWeight: 600,
  color: '#9a3412',
  background: '#fff7ed',
  border: '1px solid #fdba74',
  borderRadius: 999,
  padding: '6px 10px'
};

const primaryButtonStyle = {
  background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
  color: '#fff',
  border: 'none',
  borderRadius: 12,
  padding: '12px 22px',
  fontSize: 15,
  fontWeight: 700,
  cursor: 'pointer',
  width: '100%',
  maxWidth: 220,
  boxShadow: '0 10px 24px rgba(5, 150, 105, 0.18)'
};

const ghostButtonStyle = {
  background: '#fff',
  color: '#111827',
  border: '1px solid #d1d5db',
  borderRadius: 12,
  padding: '12px 18px',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer'
};

function StatChip({ label, value, tone = 'green' }) {
  const style = tone === 'orange' ? dangerTagStyle : tagStyle;
  return (
    <div style={style}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function FormField({ label, help, children }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ fontSize: 14, fontWeight: 700, color: '#374151', marginBottom: 8, display: 'block' }}>
        {label}
      </label>
      {children}
      {help ? <div style={helpStyle}>{help}</div> : null}
    </div>
  );
}

function ToggleField({ label, help, checked, onChange, disabled = false }) {
  return (
    <div style={{ padding: '12px 14px', border: '1px solid #e5e7eb', borderRadius: 12, background: disabled ? '#f9fafb' : '#fff' }}>
      <div style={labelRowStyle}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{label}</div>
          {help ? <div style={{ ...helpStyle, marginTop: 4 }}>{help}</div> : null}
        </div>
        <label className="switch" style={{ flexShrink: 0 }}>
          <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
          <span className="slider round"></span>
        </label>
      </div>
    </div>
  );
}

const ConfiguracoesIA = () => {
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const usuario_id = Number(usuario?.id || 0);

  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [limpando, setLimpando] = useState(false);
  const [mensagem, setMensagem] = useState('');

  const [iaAtiva, setIaAtiva] = useState(false);
  const [modelo, setModelo] = useState('gpt-4.1');
  const [prompt, setPrompt] = useState('');
  const [mensagemSaudacao, setMensagemSaudacao] = useState('');

  const [modoTreinamento, setModoTreinamento] = useState(false);
  const [leadTreinamentoId, setLeadTreinamentoId] = useState('');
  const [leads, setLeads] = useState([]);

  const [inatividadeAtiva, setInatividadeAtiva] = useState(false);
  const [mensagemInatividade, setMensagemInatividade] = useState('');
  const [inatividadeHoras, setInatividadeHoras] = useState(4);
  const [novoLeadDias, setNovoLeadDias] = useState(2);
  const [leadTreinamentoLabel, setLeadTreinamentoLabel] = useState('');

  const [regras, setRegras] = useState(DEFAULT_REGRAS);

  const [buscaLead, setBuscaLead] = useState('');

  const leadSelecionado = useMemo(
    () => leads.find((l) => String(l.id) === String(leadTreinamentoId)),
    [leads, leadTreinamentoId]
  );

  const telefoneLeadSelecionado = leadSelecionado?.telefone || '';

  useEffect(() => {
    carregarConfiguracoes();
  }, []);

useEffect(() => {
  if (!modoTreinamento) return;

  const delay = setTimeout(() => {
    carregarLeads(buscaLead);
  }, 300);

  return () => clearTimeout(delay);
}, [modoTreinamento, buscaLead]);

const carregarLeadSelecionado = async (leadId) => {
  try {
    const res = await axios.get('https://welaunchyou.com.br/crm-wly/getLeads.php', {
      withCredentials: true,
      params: { q: leadId, limite: 20 }
    });

    if (Array.isArray(res.data) && res.data.length > 0) {
      const lead = res.data.find((l) => String(l.id) === String(leadId));
      if (lead) {
        setLeads((prev) => {
          const jaExiste = prev.some((p) => String(p.id) === String(lead.id));
          return jaExiste ? prev : [lead, ...prev];
        });
        setLeadTreinamentoLabel(`${lead.nome}${lead.telefone ? ` (${lead.telefone})` : ''}`);
        setBuscaLead(lead.nome || '');
      }
    }
  } catch (err) {
    console.error('Erro ao carregar lead selecionado:', err);
  }
};

  const carregarConfiguracoes = async () => {
    try {
      const res = await axios.get(`${API_BASE}/configuracoes.php`, {
        params: { usuario_id },
        withCredentials: true
      });

      const dados = res.data || {};

      setIaAtiva(dados.ia_ativa === true || dados.ia_ativa === 1 || dados.ia_ativa === '1');
      setModelo(dados.modelo_openai || 'gpt-4.1');
      setPrompt(typeof dados.prompt_base === 'string' ? dados.prompt_base : '');
      setModoTreinamento(dados.modo_treinamento === 1 || dados.modo_treinamento === true);
      setLeadTreinamentoId(dados.lead_treinamento_id || '');

      if (dados.lead_treinamento_nome) {
        const label = `${dados.lead_treinamento_nome}${dados.lead_treinamento_telefone ? ` (${dados.lead_treinamento_telefone})` : ''}`;
        setLeadTreinamentoLabel(label);
        setBuscaLead(dados.lead_treinamento_nome);
      }

      setInatividadeAtiva(dados.inatividade_ativa === 1 || dados.inatividade_ativa === true || dados.inatividade_ativa === '1');
      setMensagemInatividade(dados.mensagem_inatividade || '');
      setInatividadeHoras(typeof dados.inatividade_horas === 'number' ? dados.inatividade_horas : parseInt(dados.inatividade_horas || '4', 10));
      setNovoLeadDias(typeof dados.novo_lead_dias === 'number' ? dados.novo_lead_dias : parseInt(dados.novo_lead_dias || '2', 10));
      setMensagemSaudacao(typeof dados.mensagem_saudacao === 'string' ? dados.mensagem_saudacao : '');

      if (dados.regras_json) {
        try {
          const parsed = typeof dados.regras_json === 'string' ? JSON.parse(dados.regras_json) : dados.regras_json;
          if (parsed && typeof parsed === 'object') {
            setRegras((prev) => ({ ...prev, ...parsed }));
          }
        } catch (e) {
          console.warn('Erro ao parsear regras_json:', e);
        }
      }
    } catch (err) {
      console.error('Erro ao carregar configurações:', err);
      setMensagem('Erro ao carregar configurações.');
    } finally {
      setLoading(false);
    }
  };

const carregarLeads = async (termo = '') => {
  try {
    const params = { limite: 100 };

    if (termo && termo.trim() !== '') {
      params.q = termo.trim();
    }

    const res = await axios.get('https://welaunchyou.com.br/crm-wly/getLeads.php', {
      withCredentials: true,
      params
    });

    if (Array.isArray(res.data)) {
      setLeads(res.data);
    } else {
      setLeads([]);
    }
  } catch (err) {
    console.error('Erro ao carregar leads:', err);
    setLeads([]);
  }
};


  const limparHistorico = async () => {
    if (!leadTreinamentoId) {
      setMensagem('Selecione um lead antes de limpar o histórico.');
      return;
    }
    if (!telefoneLeadSelecionado) {
      setMensagem('Não encontrei o telefone do lead selecionado.');
      return;
    }

    const confirma = window.confirm(
      `Tem certeza que deseja apagar TODO o histórico deste lead?\nTelefone: ${telefoneLeadSelecionado}\nEssa ação não pode ser desfeita.`
    );
    if (!confirma) return;

    try {
      setLimpando(true);
      setMensagem('');
      await axios.post(
        `${API_BASE}/limpar_historico.php`,
        { usuario_id, lead_id: leadTreinamentoId, telefone: telefoneLeadSelecionado || '' },
        { withCredentials: true, headers: { 'Content-Type': 'application/json' } }
      );
      setMensagem('Histórico apagado com sucesso!');
    } catch (err) {
      console.error('Erro ao limpar histórico:', err);
      setMensagem('Erro ao limpar histórico. Tente novamente.');
    } finally {
      setLimpando(false);
    }
  };

  const salvar = async () => {
    setSalvando(true);
    setMensagem('');

    try {
      const payload = {
        usuario_id,
        modelo_openai: modelo,
        prompt_base: prompt,
        regras_json: regras,
        ia_ativa: iaAtiva ? 1 : 0,
        modo_treinamento: modoTreinamento ? 1 : 0,
        lead_treinamento_id: modoTreinamento ? leadTreinamentoId : '',
        memoria_dias: 3,
        inatividade_ativa: inatividadeAtiva ? 1 : 0,
        mensagem_inatividade: mensagemInatividade,
        inatividade_horas: Math.max(1, parseInt(inatividadeHoras || 4, 10)),
        novo_lead_dias: Math.max(1, parseInt(novoLeadDias || 2, 10)),
        mensagem_saudacao: mensagemSaudacao
      };

      await axios.post(`${API_BASE}/configuracoes.php`, payload, {
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' }
      });

      setMensagem('Configurações salvas com sucesso!');
    } catch (err) {
      console.error('Erro ao salvar configurações:', err);
      setMensagem('Erro ao salvar configurações.');
    } finally {
      setSalvando(false);
    }
  };

  const resetarRegras = () => {
    const confirma = window.confirm('Deseja restaurar as regras automáticas padrão?');
    if (!confirma) return;
    setRegras(DEFAULT_REGRAS);
  };

  const resumo = useMemo(() => {
    return [
      { label: 'IA', value: iaAtiva ? 'Ativa' : 'Desligada', tone: iaAtiva ? 'green' : 'orange' },
      { label: 'Treinamento', value: modoTreinamento ? 'Ligado' : 'Desligado', tone: modoTreinamento ? 'orange' : 'green' },
      { label: 'Preço', value: regras.allow_prices ? 'Livre' : 'Bloqueado', tone: regras.allow_prices ? 'orange' : 'green' },
      { label: 'Lista de produtos', value: regras.availability_mode === 'whitelist_only' ? 'Restrita' : 'Livre', tone: regras.availability_mode === 'whitelist_only' ? 'green' : 'orange' }
    ];
  }, [iaAtiva, modoTreinamento, regras]);

  if (loading) {
    return (
      <div style={{ padding: 30 }}>
        <div style={{ ...cardStyle, textAlign: 'center', fontWeight: 600 }}>Carregando configurações…</div>
      </div>
    );
  }

  

  return (
    <div style={{ padding: 8 }}>
      <div style={{
        ...cardStyle,
        background: 'linear-gradient(135deg, #0f172a 0%, #1f2937 100%)',
        color: '#fff',
        border: 'none'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Configurações da IA</div>
            <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.78)', maxWidth: 760, lineHeight: 1.6 }}>
              Personalize como a IA deve atender seus contatos, responder mensagens e encaminhar casos que precisam de atendimento humano.
            </div>
          </div>

          <div style={{
            background: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.14)',
            borderRadius: 14,
            padding: '12px 14px',
            minWidth: 220
          }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', marginBottom: 4 }}>Assistente virtual</div>
            <div style={{ fontSize: 20, fontWeight: 800 }}>Configuração ativa</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.72)', marginTop: 6 }}>
              Ajuste abaixo como a IA deve atender seus contatos.
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 18 }}>
          {resumo.map((item) => (
            <StatChip key={item.label} label={item.label} value={item.value} tone={item.tone} />
          ))}
        </div>
      </div>

      {mensagem ? (
        <div style={{
          ...cardStyle,
          background: mensagem.toLowerCase().includes('erro') ? '#fff7ed' : '#ecfdf5',
          borderColor: mensagem.toLowerCase().includes('erro') ? '#fdba74' : '#86efac',
          color: mensagem.toLowerCase().includes('erro') ? '#9a3412' : '#166534',
          padding: '14px 18px'
        }}>
          <strong>{mensagem}</strong>
        </div>
      ) : null}

      <div style={grid2}>
        <div style={{ minWidth: 0 }}>
          <div style={cardStyle}>
            <div style={sectionTitleStyle}>Operação geral</div>
            <div style={sectionDescStyle}>
              Ative a IA, configure o fluxo de treinamento e ajuste a saudação inicial do primeiro contato.
            </div>

            <div style={{ display: 'grid', gap: 12 }}>
              <ToggleField
                label="Ativar IA"
                help="Quando desligada, a automação geral fica inativa."
                checked={iaAtiva}
                onChange={() => {
                  const novoValor = !iaAtiva;
                  setIaAtiva(novoValor);

                  if (novoValor) {
                    if (modoTreinamento) setModoTreinamento(false);
                  } else {
                    if (inatividadeAtiva) setInatividadeAtiva(false);
                    if (modoTreinamento) setModoTreinamento(false);
                  }
                }}
              />

              <ToggleField
                label="Modo treinamento"
                help="Faz a IA responder apenas o lead selecionado abaixo."
                checked={modoTreinamento}
                onChange={() => {
                  const novoValor = !modoTreinamento;
                  if (novoValor) {
                    if (iaAtiva) setIaAtiva(false);
                    if (inatividadeAtiva) setInatividadeAtiva(false);
                    setModoTreinamento(true);
                  } else {
                    setModoTreinamento(false);
                  }
                }}
              />
            </div>

            {modoTreinamento && (
              <div style={{
                marginTop: 16,
                padding: 14,
                border: '1px solid #fde68a',
                background: '#fffbeb',
                borderRadius: 12
              }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#92400e', marginBottom: 10 }}>
                  Modo treinamento ativo
                </div>

                <FormField label="Buscar lead para treinar">
  <input
    type="text"
    placeholder="Digite nome ou telefone..."
    value={buscaLead}
    onChange={(e) => setBuscaLead(e.target.value)}
    style={inputStyle}
  />
</FormField>

<FormField label="Selecionar lead">
  <select
    value={leadTreinamentoId}
    onChange={(e) => setLeadTreinamentoId(parseInt(e.target.value))}
    style={inputStyle}
  >
    <option value="">
      {leadTreinamentoLabel || 'Selecione um lead'}
    </option>

    {leads.map((lead) => (
      <option key={lead.id} value={lead.id}>
        {lead.nome} {lead.telefone ? `(${lead.telefone})` : ''}
      </option>
    ))}
  </select>
</FormField>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  <button
                    type="button"
                    onClick={limparHistorico}
                    disabled={!leadTreinamentoId || limpando}
                    style={{
                      ...ghostButtonStyle,
                      opacity: (!leadTreinamentoId || limpando) ? 0.55 : 1
                    }}
                    title="Apaga mensagens, logs e pendências de envio deste lead"
                  >
                    {limpando ? 'Limpando histórico…' : 'Limpar histórico do lead'}
                  </button>
                </div>
              </div>
            )}

            <div style={{ marginTop: 18 }}>
              <FormField
                label="Mensagem de saudação"
                help="Essa mensagem pode ser enviada no primeiro contato, antes do restante do fluxo."
              >
                <textarea
                  rows={4}
                  placeholder="Ex.: Olá! Que bom receber seu contato 😊 Vou te ajudar por aqui."
                  value={mensagemSaudacao}
                  onChange={(e) => setMensagemSaudacao(e.target.value)}
                  style={{ ...inputStyle, resize: 'vertical', minHeight: 110 }}
                />
              </FormField>
            </div>
          </div>

          <div style={cardStyle}>
            <div style={sectionTitleStyle}>Mensagem por inatividade</div>
            <div style={sectionDescStyle}>
              Reengaje leads novos de forma automática dentro da janela de operação do sistema.
            </div>

            <ToggleField
              label="Ativar mensagem por inatividade"
              help="Só pode ser usada com a IA geral ligada e o modo treinamento desligado."
              checked={inatividadeAtiva}
              onChange={() => {
                const novoValor = !inatividadeAtiva;
                if (novoValor && !iaAtiva) {
                  setMensagem('Para ativar a Mensagem por Inatividade, ative a IA primeiro.');
                  return;
                }
                if (novoValor && modoTreinamento) {
                  setMensagem('Desative o Modo Treinamento para usar a Mensagem por Inatividade.');
                  return;
                }
                setInatividadeAtiva(novoValor);
              }}
            />

            <div style={{ marginTop: 16, ...grid2 }}>
              <FormField
                label="Horas sem resposta"
                help="Tempo mínimo sem mensagem do lead para disparar a automação."
              >
                <input
                  type="number"
                  min={1}
                  value={inatividadeHoras}
                  onChange={(e) => setInatividadeHoras(e.target.value)}
                  style={inputStyle}
                  disabled={!inatividadeAtiva || !iaAtiva}
                />
              </FormField>

              <FormField
                label="Dias para considerar lead novo"
                help="Somente leads cadastrados nos últimos X dias entram nessa regra."
              >
                <input
                  type="number"
                  min={1}
                  value={novoLeadDias}
                  onChange={(e) => setNovoLeadDias(e.target.value)}
                  style={inputStyle}
                  disabled={!inatividadeAtiva || !iaAtiva}
                />
              </FormField>
            </div>

            <FormField
              label="Mensagem de inatividade"
              help="Se deixar em branco, a IA pode gerar uma mensagem curta automaticamente."
            >
              <textarea
                rows={5}
                value={mensagemInatividade}
                onChange={(e) => setMensagemInatividade(e.target.value)}
                disabled={!inatividadeAtiva || !iaAtiva}
                placeholder="Deixe em branco para geração automática."
                style={{ ...inputStyle, resize: 'vertical', minHeight: 130 }}
              />
            </FormField>
          </div>
        </div>

        <div style={{ minWidth: 0 }}>
          <div style={cardStyle}>
            <div style={sectionTitleStyle}>Regras estruturadas da IA</div>
            <div style={sectionDescStyle}>
              Essas regras dão previsibilidade operacional e ajudam o backend a validar as respostas antes do envio.
            </div>

            <div style={{ ...grid2, marginBottom: 8 }}>
              <FormField
                label="Limite de caracteres"
                help="Tamanho máximo da resposta final enviada ao lead."
              >
                <input
                  type="number"
                  min={30}
                  max={1000}
                  value={regras.max_chars}
                  onChange={(e) => setRegras({ ...regras, max_chars: parseInt(e.target.value || 150, 10) })}
                  style={inputStyle}
                />
              </FormField>

              <FormField
                label="Máximo de vezes para pedir o nome"
                help="Define quantas vezes a IA pode perguntar o nome do contato ao longo da conversa."
              >
                <input
                  type="number"
                  min={0}
                  max={10}
                  value={regras.use_name_max_times}
                  onChange={(e) =>
                    setRegras({
                      ...regras,
                      use_name_max_times: parseInt(e.target.value || 0, 10)
                    })
                  }
                  style={inputStyle}
                />
              </FormField>
            </div>

            <div style={{ display: 'grid', gap: 12, marginBottom: 16 }}>
              <ToggleField
                label="Bloquear preços"
                help="Quando ligado, a IA não informa valores diretamente ao contato."
                checked={!regras.allow_prices}
                onChange={(e) => setRegras({ ...regras, allow_prices: !e.target.checked })}
              />

              <ToggleField
                label="Limitar pedidos de nome"
                help="Quando ligado, a IA respeita o número máximo definido abaixo para pedir o nome do contato."
                checked={regras.ask_name_once}
                onChange={(e) => setRegras({ ...regras, ask_name_once: e.target.checked })}
              />

              <ToggleField
                label="Transferir quando perguntarem preço"
                help="Aciona handoff automático para humano nesses casos."
                checked={regras.handoff_on_price}
                onChange={(e) => setRegras({ ...regras, handoff_on_price: e.target.checked })}
              />

              <ToggleField
                label="Transferir quando pedirem imagens"
                help="Útil quando fotos, catálogos visuais ou mídia precisam de confirmação humana."
                checked={regras.handoff_on_image_request}
                onChange={(e) => setRegras({ ...regras, handoff_on_image_request: e.target.checked })}
              />

              <ToggleField
                label="Transferir revenda / atacado / fornecedor"
                help="Quando ligado, o sistema trata esse tipo de intenção como fluxo humano."
                checked={regras.handoff_on_wholesale}
                onChange={(e) => setRegras({ ...regras, handoff_on_wholesale: e.target.checked })}
              />
            </div>

            <FormField
              label="Frase de transferência"
              help="Mensagem padrão usada quando o backend decidir encaminhar o atendimento."
            >
              <textarea
                rows={4}
                value={regras.handoff_phrase}
                onChange={(e) => setRegras({ ...regras, handoff_phrase: e.target.value })}
                style={{ ...inputStyle, resize: 'vertical', minHeight: 110 }}
              />
            </FormField>

            <FormField
              label="Modo de disponibilidade"
              help="Restrito = só responde produtos/serviços presentes na lista autorizada do prompt. Livre = resposta mais aberta."
            >
              <select
                value={regras.availability_mode}
                onChange={(e) => setRegras({ ...regras, availability_mode: e.target.value })}
                style={inputStyle}
              >
                <option value="whitelist_only">Somente lista autorizada</option>
                <option value="free">Livre</option>
              </select>
            </FormField>

            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <button type="button" style={ghostButtonStyle} onClick={resetarRegras}>
                Restaurar regras padrão
              </button>
            </div>
          </div>

          <div style={cardStyle}>
            <div style={sectionTitleStyle}>Prompt estratégico</div>
            <div style={sectionDescStyle}>
              Use o prompt para orientar persona, contexto do negócio, catálogo, scripts e exceções. Deixe as regras operacionais nos blocos acima.
            </div>

            <FormField
              label="Prompt base"
              help="Quanto mais contexto relevante e organizado, melhor a IA entende o negócio. Evite repetir regras que já existem em campos estruturados."
            >
              <textarea
                rows={16}
                placeholder="Digite aqui o prompt de treinamento do seu Agente IA."
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                style={{ ...inputStyle, resize: 'vertical', minHeight: 320, background: '#f9fafb' }}
              />
            </FormField>

            <div style={{
              border: '1px dashed #d1d5db',
              borderRadius: 14,
              padding: 16,
              background: '#fafafa'
            }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#111827', marginBottom: 8 }}>
                Dica de configuração SaaS
              </div>
              <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.65 }}>
                Deixe no prompt apenas <strong>persona</strong>, <strong>contexto do negócio</strong>,
                <strong> catálogos</strong>, <strong>fluxos</strong> e <strong>respostas especiais</strong>.
                Regras como preço, handoff e limite de caracteres devem ficar no painel estruturado.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800, color: '#111827' }}>Salvar configurações</div>
            <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>
              As alterações abaixo serão aplicadas no atendimento automático da IA.
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button
              onClick={salvar}
              disabled={salvando}
              type="button"
              style={{ ...primaryButtonStyle, opacity: salvando ? 0.7 : 1 }}
            >
              {salvando ? 'Salvando…' : 'Salvar alterações'}
            </button>
          </div>
                {mensagem ? (
        <div style={{
          ...cardStyle,
          background: mensagem.toLowerCase().includes('erro') ? '#fff7ed' : '#ecfdf5',
          borderColor: mensagem.toLowerCase().includes('erro') ? '#fdba74' : '#86efac',
          color: mensagem.toLowerCase().includes('erro') ? '#9a3412' : '#166534',
          padding: '14px 18px'
        }}>
          <strong>{mensagem}</strong>
        </div>
      ) : null}
        </div>
      </div>
    </div>
  );
};

export default ConfiguracoesIA;
